import React from 'react';
import { hasErrorCode } from '@/utils/errors';
import errorCodes from '@/constants/errors';
import NotAuthorised from './NotAuthorised';
import NotFound from './NotFound';

const BasicAuthErrorsWrapper = ({ children, className, errors }) => {
  if (hasErrorCode(errors, errorCodes.notFound)) { return <NotFound className={className} />; }
  if (hasErrorCode(errors, errorCodes.forbidden)) { return (<NotAuthorised className={className} />); }
  return (<>{ children }</>);
};

export default BasicAuthErrorsWrapper;
